import {
    CONFIRMED_GET_LEAD_NOTES,
    CONFIRMED_CREATE_LEAD_NOTE_ACTION,
  } from "./LeadNotetype.js";
  
  import {
    createLeadNote,
    getLeadNotes,
    formatLeadNotes
  } from "../../services/LeadNoteService.js";
  
  import swal from "sweetalert";
  import {
    handleError,
    handleSuccess,
    showErrorAlert,
  } from "../../services/ErrorHandlingService.js";
  
  
  // Utility: Get Auth Token from Redux or LocalStorage
  function getAuthToken(getState) {
    const stateToken = getState().auth?.authKey;
    if (stateToken) return stateToken;
  
    const storedUser = localStorage.getItem("userDetails");
    return storedUser ? JSON.parse(storedUser).token : null;
  }
  
  // Action: Fetch Notes
 // Fetch Lead Notes
export function getLeadNotesAction(lead_id) {
    return async (dispatch, getState) => {
      if (!lead_id) {
        swal("Error", "Lead ID not found", "error");
        return;
      }
  
      try {
        const response = await getLeadNotes(lead_id);
  
        if (response && response.status === 200 && response.data) {
          if (response.data.status === "success" && response.data.data) {
            const notes = formatLeadNotes(response.data.data);
            dispatch({
              type: CONFIRMED_GET_LEAD_NOTES,
              payload: notes,
            });
          } else {
            handleError("Failed to get lead notes: Server error");
          }
        } else {
          handleError("Failed to get lead notes: Network error");
        }
      } catch (error) {
        console.error("API Error:", error.response || error);
        showErrorAlert("Failed to get lead notes");
      }
    };
  }

  // Create Lead Note
export function createLeadNoteAction(noteData, lead_id) {
    return async (dispatch, getState) => {
      if (!lead_id) {
        swal("Error", "Lead ID not found", "error");
        return;
      }
  
      const singleNote = {
        lead_id,
        note: noteData.note,
      };
  
      try {
        const response = await  createLeadNote(singleNote);
  
        if (response && response.status === 200 && response.data) {
          if (response.data.status === "success") {
            dispatch({
              type: CONFIRMED_CREATE_LEAD_NOTE_ACTION,
              payload: {
                ...singleNote,
                note_id: response.data.note_id || Date.now(),
                created_at: new Date().toISOString(),
              },
            });
            handleSuccess("Note created successfully!", "success");
            return { success: true };
          } else {
            showErrorAlert(
              
              "Failed to create lead note: " + (response.data.message || "Server error")
            );
            return { success: false };
          }
        } else {
          showErrorAlert("Failed to create lead note");
          return { success: false };
        }
      } catch (error) {
        console.error("API Error:", error.response || error);
        showErrorAlert(
          
          "Failed to create lead note: " + (error.message || "Network error")
        );
        return { success: false };
      }
    };
  }
  
  